import { ButtonProps } from '@ui/buttons/Button/types'
import ButtonsFixed from '@ui/buttons/ButtonsFixed'
import { useTranslation } from 'react-i18next'
import {
  interpolate,
  SharedValue,
  useAnimatedStyle,
} from 'react-native-reanimated'

const MOVE = 200

interface Props {
  animation: SharedValue<number>
  next: () => void
  prev: () => void
  hasNext?: boolean
  hasPrev?: boolean
  onConfirm?: () => void
  index: number
  total: number
}

export default function RecommendationButtons({
  animation,
  next,
  prev,
  hasNext,
  hasPrev,
  onConfirm,
  index,
  total,
}: Props) {
  const { t } = useTranslation(['ui'])

  const styleRecommended = useAnimatedStyle(() => {
    return {
      transform: [
        {
          translateY: interpolate(
            animation.value,
            [index - 1, index, index + 1],
            [MOVE, 0, MOVE]
          ),
        },
      ],
      opacity: interpolate(
        animation.value,
        [index - 1, index, index + 1],
        [0, 1, 0]
      ),
    }
  })

  const hasNextAndConfirm = hasNext && !!onConfirm

  return (
    <>
      <ButtonsFixed.Buttons
        disableTransitions
        style={styleRecommended}
        // Looks bit ugly maybe fix this later
        buttons={[
          hasNext &&
            ({
              variant: 'outlined',
              label: t('ui:noThanks'),
              onPress: next,
            } as const),

          hasPrev &&
            !hasNextAndConfirm &&
            total < 3 &&
            ({
              variant: 'outlined',
              label: t('ui:recommendedOptions'),
              onPress: prev,
              iconStart: 'arrow-narrow-left',
            } as const),
          !!onConfirm &&
            ({
              variant: 'filled',
              label: t('ui:confirm'),
              onPress: onConfirm,
              iconEnd: 'check',
            } as const),
        ].filter((v) => !!v)}
      />
    </>
  )
}
